<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <report-tools
        @carList="reCarLists"
        @timeObj="reTimeObj"
        @exportAll="exportAll"
        @alarmData="reAlarmList"
        model="1,2"
      ></report-tools>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
        },{
          title: "设备号",
          key: "deviceNo",
        },
        {
          title: "单位名称",
          key: "groupName",
        },
        {
          title: "驾驶员",
          key: "driverName",
        },
        {
          title: "报警类型",
          key: "alarmTypeName",
        },
        {
          title: "开始时间",
          key: "startTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime));
          },
        },{
          title: "结束时间",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTime));
          },
        },
      ],
      tableData: [],
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      timeObj: {},
      deviceIdList: [],
      alarmIdList: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      let params = {
        deviceIdList: this.deviceIdList,
        alarmIdList:this.alarmIdList,
        endTime: this.timeObj.end,
        startTime: this.timeObj.start,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
      };
      console.log(params)
      axios({
        method: "post",
        url: axios.alarm + "/alarm/list",
        data:params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          console.log(data);
          this.tableData = data;
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.deviceIdList,
        },
        {
          name: "startTime",
          value: this.timeObj.start,
        },
        {
          name: "endTime",
          value: this.timeObj.end,
        },
      ];
      this.utils.exportData(axios.report + "/countDaily/export", params);
    },
    reCarLists(x) {
      this.deviceIdList = [];
      for (const i in x) {
        this.deviceIdList.push(x[i].deviceId);
      }
      this.getList();
    },
    reAlarmList(v) {
      this.alarmIdList = v;
      this.getList();
    },
    reTimeObj(x) {
      this.timeObj = x;
      this.getList();
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/notice/alarmNotice.vue